<!-- Always visible header and search field -->
<div class="child_section_title" style="margin-bottom: 0px">
    <h3>{{ itemsCopyDisplay?.name }}</h3>
</div>

<div class="filter_section">
    <div class="search-wrapper m-2">
        <mat-form-field>
            <input matInput type="text" placeholder="Search" (keyup)="searchResult($event)" [(ngModel)]="searchInput" />
            <button mat-button matPrefix mat-icon-button class="search_btn">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>

<!-- Conditionally rendered content based on searchInput and items presence -->
<ng-container *ngIf="itemsCopyDisplay?.items?.length">
    <div *ngIf="itemsCopyDisplay?.items?.length">
        <div class="section">
            <div class="instance_data">
                <div *ngFor="let item of itemsCopyDisplay.items; trackBy: trackById" id="{{ item?.allowedItemTypeId }}">
                    <div class="plant-section">
                        <div
                            class="child_section"
                            style="cursor: pointer"
                            (click)="itemSelected(item)"
                            [class.toggled]="item === selectedItem"
                            [class.no-hover]="!item?.items?.length"
                            [style.cursor]="item?.items?.length > 0 ? 'pointer' : 'default'"
                        >
                            <p>
                                <a>{{ item?.name }}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="add_more" *ngIf="_items.items.length > 5">
            <a href="javascript:void(0)" (click)="clickMore()">MORE +</a>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="searchInput && !itemsCopyDisplay?.items?.length">
    <div class="section">
        <div class="instance_data">
            <div class="plant-section">
                <p class="error-message">No data found</p>
            </div>
        </div>
    </div>
</ng-container>
